import moment from "moment";
import {FilterTypes} from "../constans/filter";

export const rangeRegex = new RegExp(
    "([\\[\\(])\\s*(-?\\d+)\\s*-\\s*(-?\\d+)\\s*([\\]\\)])"
);
export const operationRegex = new RegExp("(>=|<=|>|<|=|<>)(-?\\d+)");

export const dateRegex = new RegExp(
    "(\\d{2,4})[-\\.\\/](\\d{2})[-\\.\\/](\\d{2,4})",
    "g"
);

export const operationDateRegex = new RegExp(
    "(>=|<=|>|<|=|<>)(\\d{2,4})[-\\.\\/](\\d{2})[-\\.\\/](\\d{2,4})"
);

const yearFirstFormats = ["YYYY/MM/DD", "YYYY.MM.DD", "YYYY-MM-DD"];
const monthFirstFormats = ["MM/DD/YYYY", "MM.DD.YYYY", "MM-DD-YYYY"];
const dayFirstFormats = ["DD/MM/YYYY", "DD.MM.YYYY", "DD-MM-YYYY"];

function tryToParseDate(string, formats) {
    for (let format of formats) {
        const parsed = moment(string, format);
        if (parsed.isValid()) return parsed;
    }
    return null;
}

function getFormat(string) {
    if (
        string.split("/")[0].length === 4 ||
        string.split("-")[0].length === 4 ||
        string.split(".")[0].length === 4
    )
        return "year";
    if (moment.localeData().longDateFormat("L").startsWith("MM"))
        return "month";
    return "day";
}

export function parseDate(string) {
    const format = getFormat(string);
    switch (format) {
        case "year": {
            return tryToParseDate(string, yearFirstFormats);
        }
        case "month": {
            return tryToParseDate(string, monthFirstFormats);
        }
        default:
            return tryToParseDate(string, dayFirstFormats);
    }
    // if (
    //     string.split("/")[0].length === 4 ||
    //     string.split("-")[0].length === 4 ||
    //     string.split(".")[0].length === 4
    // ) {
    //     const parsed = tryToParseDate(string, yearFirstFormats);
    //     if (parsed) return parsed;
    // }
    // if (moment.localeData().longDateFormat("L").startsWith("MM")) {
    //     const parsed = tryToParseDate(string, monthFirstFormats);
    //     if (parsed) return parsed;
    // } else {
    //     const parsed = tryToParseDate(string, dayFirstFormats);
    //     if (parsed) return parsed;
    // }
    // return null;
}

export function getStringFilterParams(value) {
    if (Array.isArray(value)) {
        if (value.length === 0) return null;
        return {type: "IN", value};
    }
    return {type: "LIKE", value};
}

// liczba z kropka lub przecinkiem dziesietnym; wpis musi pasowac w calosci, zeby ">15abc" nie dalo "> 15"
const numberPattern = "-?\\d+(?:[.,]\\d+)?";
const fullRangeRegex = new RegExp(
    `^\\s*([\\[\\(])\\s*(${numberPattern})\\s*-\\s*(${numberPattern})\\s*([\\]\\)])\\s*$`
);
const fullOperationRegex = new RegExp(
    `^\\s*(>=|<=|<>|>|<|=)?\\s*(${numberPattern})\\s*$`
);

const normalizeNumber = (number) => number.replace(",", ".");

/**
 * Filtr liczbowy w formacie API.
 * @param {string} value "15", ">15", "<>15", "[0 - 7)", "(-5 - -1]", "95,5"
 * @returns {{type: string, value: string|string[]}|null} null - bledny wpis
 */
export function getNumberFilterParams(value) {
    const rangeMatch = value.match(fullRangeRegex);
    if (rangeMatch) {
        const type = `${rangeMatch[1]}${rangeMatch[4]}`;
        return {
            type,
            value: [
                normalizeNumber(rangeMatch[2]),
                normalizeNumber(rangeMatch[3]),
            ],
        };
    }
    const operationMatch = value.match(fullOperationRegex);
    if (!operationMatch) return null;
    return {
        type: operationMatch[1] || "=",
        value: normalizeNumber(operationMatch[2]),
    };
}

function splitDate(dateString) {
    if (dateString.includes(".")) return dateString.split(".");
    if (dateString.includes("/")) return dateString.split("/");
    return dateString.split("-");
}

export function getDateFilterParams(rawValue) {
    const value = rawValue.trim();
    const dates = value.match(dateRegex);
    if (dates && dates.length > 1) {
        const lowerBound = parseDate(dates[0]);
        const upperBound = parseDate(dates[1]);

        if (!lowerBound || !upperBound) return null;

        // rodzaj granic z nawiasow na brzegach wpisu: "[)", "(]", ...
        const type = `${value[0]}${value[value.length - 1]}`;
        if (!/^[[(][\])]$/.test(type)) return null;
        return {
            type,
            value: [
                lowerBound.format(moment.HTML5_FMT.DATE),
                upperBound.format(moment.HTML5_FMT.DATE),
            ],
        };
    }
    let operationMatch = value.match(operationDateRegex);
    let operator = operationMatch?.[1] || "=";
    let dateString = operationMatch
        ? `${operationMatch[2]}-${operationMatch[3]}-${operationMatch[4]}`
        : value;
    if (dateString.includes("?")) {
        const possibleFormat = getFormat(dateString);
        switch (possibleFormat) {
            case "year":
                return {
                    type: operator,
                    value: dateString.replace(".", "-").replace("/", "-"),
                };
            case "month": {
                const split = splitDate(dateString);
                return {
                    type: operator,
                    value: `${split[2]}-${split[0]}-${split[1]}`,
                };
            }
            default: {
                const split = splitDate(dateString);
                return {
                    type: operator,
                    value: `${split[2]}-${split[1]}-${split[0]}`,
                };
            }
        }
    }
    let operationValue = parseDate(dateString);
    if (!operationValue) return null;
    return {
        type: operator,
        value: operationValue.format(moment.HTML5_FMT.DATE),
    };
}

export function getFilterParams(type, value) {
    switch (type) {
        case FilterTypes.DATE:
            return getDateFilterParams(value);
        case FilterTypes.NUMBER:
            return getNumberFilterParams(value);
        default:
            return getStringFilterParams(value);
    }
}

export function hasRemovedFields(removedFields) {
    if (!removedFields || typeof removedFields !== "object") {
        return false;
    }

    return Object.values(removedFields).some((value) => {
        return Array.isArray(value) ? value.length > 0 : !!value;
    });
}
